import { createFileRoute, redirect } from '@tanstack/react-router';
import useAppStore from '../store/rootStore.ts';

export const Route = createFileRoute('/tournament')({
  beforeLoad: () => {
    const config = useAppStore.getState().config;
    if (!config?.features.tournamentEnabled || !config.competitions?.length) {
      throw redirect({ to: '/trade', replace: true });
    }
    throw redirect({ to: '/tournaments', replace: true });
  },
});
